import { createSlice } from "@reduxjs/toolkit";
import {
  approveDispute,
  disputeGetConfig,
  fetchDispute,
  fetchDisputeDetails,
  getDisputeById,
  rejectDispute,
  getDisputeStep,
  disputeDetailSave,
  updateDispute,
  getReasonForDispute,
  fetchAuditLogById,
  acknowledgeDispute,
  fetchAuditLog,
  fetchDebitAuthority,
  addReconRefrence,
  addDispute,
  fetchProActive,
  fetchAtmBalancing,
  fetchRegion,
  fetchCity,
  fetchBank,
  fetchBranch,
  fetchTerminal,
  getEscalationTime,
  fetchDAFileData,
} from "./disputeActions";

const disputeSlice = createSlice({
  name: "dispute",
  initialState: {
    entities: [],
    disputeFormConfig: [],
    disputeProcessSteps: [],
    disputeDetails: [],
    disputeById: {},
    invoiceData: {},
    formData: [],
    reasonForDispute: [],
    auditLogByIdData: [],
    auditLogData: [],
    debitAuthorityData: [],
    DAFileData: [],
    createDisputeResponse: [],
    disputeObjects: [],
    errorTransactionsData: [],
    atmBalancingData: [],
    regionData: [],
    cityData: [],
    bankData: [],
    branchData: [],
    terminalData: [],
    escalationTimeData: [],
    loading: false,
    error: null,
    total: 0,
    disputeRejectStatus: 0,
    disputedAmount: 0,
    disputeDataFetched: false,
    addDisputeSuccess: false,
  },
  reducers: {
    setFormRecords: (state, { payload }) => {
      state.formData = payload;
    },

    setDisputedAmount: (state, { payload }) => {
      console.log("pop", payload);

      state.disputedAmount = payload.total;
    },

    setDisputeObjects: (state, { payload }) => {
      console.log("pop", payload);

      state.disputeObjects = payload;
    },

    setDisputeFormConfigCleanup: (state, { payload }) => {
      state.disputeFormConfig = [];
      state.disputeDataFetched = false;
    },

    resetDisputeResponse: (state) => {
      state.createDisputeResponse = [];
      state.addDisputeSuccess = false;
    },

    resetErrorTransactions: (state) => {
      state.errorTransactionsData = [];
    },

    resetProcessSteps: (state) => {
      state.disputeProcessSteps = [];
    },
    resetDisputeById: (state) => {
      state.disputeById = {};
    },
  },
  extraReducers: (builder) => {
    builder
      //pending cases
      .addCase(addDispute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addReconRefrence.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDispute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(disputeDetailSave.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveDispute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(rejectDispute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDisputeDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDispute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAtmBalancing.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuditLog.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDebitAuthority.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchDAFileData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getDisputeById.pending, (state) => {
        state.loading = true;
        state.disputeDataFetched = false;
        state.error = null;
      })
      .addCase(disputeGetConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDisputeStep.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getReasonForDispute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuditLogById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(acknowledgeDispute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProActive.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRegion.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchCity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBank.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBranch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTerminal.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getEscalationTime.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      //fulfilled cases
      .addCase(addDispute.fulfilled, (state, { payload }) => {
        state.entities.unshift(payload);
        console.log("createDisputeResponse", payload);

        state.createDisputeResponse = payload[0];
        state.loading = false;
        state.addDisputeSuccess = true;
        state.error = null;
      })
      .addCase(addReconRefrence.fulfilled, (state, { payload }) => {
        // state.entities.unshift(payload);
        // console.log('createDisputeResponse', payload);

        // state.createDisputeResponse = payload[0]
        state.loading = false;
        // state.addDisputeSuccess = true
        state.error = null;
      })
      .addCase(updateDispute.fulfilled, (state, { payload }) => {
        // state.entities.unshift(payload);

        state.loading = false;
        state.error = null;
      })
      .addCase(disputeDetailSave.fulfilled, (state, { payload }) => {
        // state.entities.unshift(payload);

        state.loading = false;
        state.error = null;
      })
      .addCase(approveDispute.fulfilled, (state, { payload }) => {
        // state.entities.unshift(payload);

        state.loading = false;
        state.error = null;
      })
      .addCase(rejectDispute.fulfilled, (state, { payload }) => {
        // state.entities.unshift(payload);
        console.log("payload", payload);

        state.loading = false;
        state.error = null;
      })
      .addCase(fetchDispute.fulfilled, (state, { payload }) => {
        console.log("dispute", payload);

        state.entities = payload.data;
        state.total = payload.totalRecords;
        // state.loading = false;
        // state.error = null;
      })
      .addCase(fetchAtmBalancing.fulfilled, (state, { payload }) => {
        console.log("atmBalancingData", payload);

        state.atmBalancingData = payload.data?.data;
        state.total = payload.data.totalRecords;
        state.loading = false;
        // state.error = null;
      })
      .addCase(fetchAuditLog.fulfilled, (state, { payload }) => {
        const data = payload?.data;

        // const parsedData = data?.map((detail) => ({
        //   ...detail,
        //   details: detail.details ? JSON.parse(detail.details) : {},
        // }));

        // console.log("Parsed data111:", parsedData);

        // // parsedData.forEach((item) => {
        // //   console.log("Details:", item.details);
        // // });

        // const combinedDetails = parsedData.flatMap((item) => item.details);
        // console.log("combinedDetails", combinedDetails);

        // console.log("popo", payload);

        state.auditLogData = data;
        // state.auditLogData = parsedData.map((item) => item.details);
        state.total = payload.totalRecords;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchDebitAuthority.fulfilled, (state, { payload }) => {
        state.debitAuthorityData = payload.data;
        state.total = payload.totalRecords;
        state.loading = false;
        state.error = null;
      })

      .addCase(fetchDAFileData.fulfilled, (state, { payload }) => {
        state.DAFileData = payload.data;
        state.total = payload.totalRecords;
        state.loading = false;
        state.error = null;
      })

      .addCase(fetchDisputeDetails.fulfilled, (state, { payload }) => {
        console.log("payloadDetails", payload);
        state.disputeDetails = payload;
        // state.total = payload.totalRecords;
        // state.loading = false;
        // state.error = null;
      })
      .addCase(getDisputeById.fulfilled, (state, { payload }) => {
        // console.log("dispute data 1", payload[0]);
        state.disputeById = payload[0];
        state.loading = false;
        state.disputeDataFetched = true;
        state.error = null;
      })
      .addCase(disputeGetConfig.fulfilled, (state, { payload }) => {
        console.log("dispute Config Slice", payload);
        state.disputeFormConfig = payload;
        state.loading = false;
        state.error = null;
      })

      .addCase(getDisputeStep.fulfilled, (state, { payload }) => {
        console.log("mbmbmbm", payload);

        const flattenedPayload = payload.flat();
        console.log("flattenedPayload", flattenedPayload);

        flattenedPayload.forEach((newStep) => {
          const existingStep = state.disputeProcessSteps.find(
            (step) => step.id === newStep.id
          );
          if (!existingStep) {
            state.disputeProcessSteps.push(newStep);
          }
        });
        state.loading = false;
        state.error = null;
      })

      .addCase(getReasonForDispute.fulfilled, (state, { payload }) => {
        console.log("getReasonForDispute", payload);

        state.reasonForDispute = payload;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchAuditLogById.fulfilled, (state, { payload }) => {
        console.log("fetchAuditLogById", payload);
        state.auditLogByIdData = payload;
        // state.total = payload.totalRecords;
        state.loading = false;
        state.error = null;
      })
      .addCase(acknowledgeDispute.fulfilled, (state, { payload }) => {
        // state.entities.unshift(payload);
        console.log("payload", payload);

        state.loading = false;
        state.error = null;
      })
      .addCase(fetchProActive.fulfilled, (state, { payload }) => {
        // state.entities = payload.data;
        // state.total = payload.totalRecords;
        // state.loading = false;
        // state.error = null;
      })

      .addCase(fetchRegion.fulfilled, (state, { payload }) => {
        console.log("fetchRegion", payload);

        state.regionData = payload.data;
        state.total = payload.totalRecords;
        // state.loading = false;
        // state.error = null;
      })

      .addCase(fetchCity.fulfilled, (state, { payload }) => {
        console.log("fetchCity", payload);

        state.cityData = payload.data;
        state.total = payload.totalRecords;
        state.loading = false;
        // state.error = null;
      })

      .addCase(fetchBank.fulfilled, (state, { payload }) => {
        console.log("fetchBank", payload);

        state.bankData = payload.data;
        state.total = payload.totalRecords;
        // state.loading = false;
        // state.error = null;
      })

      .addCase(fetchBranch.fulfilled, (state, { payload }) => {
        console.log("fetchBranch12345", payload);

        state.branchData = payload.data;
        state.total = payload.totalRecords;
        // state.loading = false;
        // state.error = null;
      })
      .addCase(fetchTerminal.fulfilled, (state, { payload }) => {
        console.log("fetchTerminal", payload);

        state.terminalData = payload.data;
        state.total = payload.totalRecords;
        // state.loading = false;
        // state.error = null;
      })
      .addCase(getEscalationTime.fulfilled, (state, { payload }) => {
        console.log("escalationTImeData", payload);

        state.escalationTimeData = payload;
        state.total = payload.totalRecords;
        // state.loading = false;
        // state.error = null;
      })

      //rejected cases
      .addCase(addDispute.rejected, (state, action) => {
        state.loading = false;
        state.addDisputeSuccess = false;
        state.error = action.payload;
      })
      .addCase(addReconRefrence.rejected, (state, action) => {
        state.loading = false;
        // state.addDisputeSuccess = false
        state.error = action.payload;
      })
      .addCase(updateDispute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(disputeDetailSave.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(approveDispute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(rejectDispute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDispute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAtmBalancing.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAuditLog.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDebitAuthority.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchDAFileData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchDisputeDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getDisputeById.rejected, (state, action) => {
        state.loading = false;
        state.disputeDataFetched = false;
        state.error = action.payload;
      })
      .addCase(disputeGetConfig.rejected, (state, action) => {
        console.error("Error in extraReducers:", action); // Improved logging
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getDisputeStep.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getReasonForDispute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAuditLogById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(acknowledgeDispute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchProActive.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchRegion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchCity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchBank.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchBranch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTerminal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getEscalationTime.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setFormRecords,
  setDisputeFormConfigCleanup,
  setDisputedAmount,
  setDisputeObjects,
  resetDisputeResponse,
  resetProcessSteps,
  resetErrorTransactions,
  resetDisputeById,
  regionData,
  cityData,
  bankData,
  branchData,
  terminalData,
  escalationTimeData,
} = disputeSlice.actions;

export default disputeSlice.reducer;
